import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPageView, trackPixelPageView } from "../helper/analytics";

/**
 * Loads GA4 once and reports a page_view on every route change. Renders nothing.
 * Must live inside <BrowserRouter> so it can use useLocation. No-ops entirely when
 * REACT_APP_GA_MEASUREMENT_ID is not set.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => { initGA(); }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
    trackPixelPageView();
  }, [location.pathname, location.search]);

  return null;
}
